import React, { forwardRef, useEffect } from "react";
import "./Button.scss";
import Loader from "./Loader";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";

const Button = forwardRef(({ onPlay, icon, text, isActive, bgColor, textColor, loading, className, event }) => {
    const { ref, focused, focusSelf } = useFocusable({
        focusKey: "SIDEPANEL_PLAY_BUTTON",
        onEnterPress: () => {
            onPlay(event);
        },
    });

    useEffect(() => {
        focusSelf()
    }, []);

    return (
        <button ref={ref} className={`button ${isActive ? "isActive" : ""} ${className} ${focused ? "focused" : ""}`} style={bgColor ? { backgroundColor: bgColor } : {}} onClick={() => onPlay(event)}>
            {loading && <Loader textColor={textColor} />}
            {!loading && icon && <span className="icon">{icon}</span>}
            {!loading && (
                <span className="text" style={textColor ? { color: textColor } : {}}>
                    {text}
                </span>
            )}
        </button>
    );
});

export default Button;
